import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { ConversationService } from '../../../../core/src/lib/state/conversation.service';
import { ConversationDetail } from '../../../../core/src/lib/interface/conversation.interface';
import { switchMap } from 'rxjs/operators';
import { toObservable } from '@angular/core/rxjs-interop';
import { filterNullAndUndefined } from '@vendasta/rx-utils';

@Component({
  selector: 'inbox-conversation-preview',
  templateUrl: './inbox-conversation-preview.component.html',
  styleUrls: ['./inbox-conversation-preview.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class InboxConversationPreviewComponent {
  readonly conversationDetail = input<ConversationDetail>();
  private readonly conversationDetail$ = toObservable(this.conversationDetail);

  private readonly conversationService = inject(ConversationService);

  protected readonly previewContent$ = this.conversationDetail$.pipe(
    filterNullAndUndefined(),
    switchMap((details) => this.conversationService.getPreviewContent(details)),
  );
}
